import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import arrayMove from "array-move";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import {
  Popover,
  OverlayTrigger,
  PopoverHeader,
  PopoverBody,
} from "react-bootstrap";
import {
  fetchManageChallengesList,
  openChallengesModal,
  updateChallengeList,
  getStaticTemplteHtml,
} from "ManagechallengesActions";
import NoContent, { NO_CHALLENGE } from "NoContent";
import { screenHeightLeftFromTop } from "Constants";
import ManagechallengesMenuIcon from "./managechallenges-menu-icon";
import ManageChallengesItem from "./managechallenges-table-list";
import ChallengeItem from "./challenge-list-item";
import EditChallenge from "./editchallenge";
import Loader from "Loader";
import LocaleStrings from "Languages";

const SortableSection = SortableElement(
  ({ value, pageDataLength, currentPage }) => (
    <div>
      {/* <DragHandle sectionname={value.id}/> */}
      <ChallengeItem
        key={value.id}
        challenge={value}
        pageDataLength={pageDataLength}
        currentPage={currentPage}
        style={{ zIndex: 10000 }}
      />
    </div>
  )
);

const SortableSectionList = SortableContainer(
  ({ collection, pageDataLength, currentPage, disabled }) => {
    return (
      <div>
        {collection.map((value, index) => {
          return (
            <SortableSection
              key={`section-${index}`}
              index={index}
              value={value}
              pageDataLength={pageDataLength}
              currentPage={currentPage}
              disabled={disabled}
            />
          );
        })}
      </div>
    );
  }
);

class ManagechallengesInside extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      desc: LocaleStrings.gamification_text_preparing_analytics,
      loader: false,
      activeLoader: false,
      searchKey: "",
      pageNumber: 1,
      activeCount: 0,
      archiveCount: 0,
      pageLoader: false,
    };
    this.eventInfoPop = React.createRef();
    this.open = this.openAddChallenge.bind(this);
    this.onSearchChallenge = this.onSearchChallenge.bind(this);
  }

  openAddChallenge() {
    this.props.openChallengesModal({
      showModal: true,
      linkFieldName: "linkedin",
      linkFieldLable: "Linkedin",
      callFor: "add",
    });
  }

  //
  componentDidMount() {
    this.setState({ loading: true });

    // Get Static content Template HTML
    this.props.getStaticTemplteHtml(
      this.props.session,
      (CallBackResponse) => {}
    );

    if (this.props.managechallengesSelectedTab == "MANAGECHALLENGES_SINGLE") {
      // For Single Chaleenges call
      this.props.fetchManageChallengesList(
        this.props.session,
        this.state.searchKey,
        "single",
        (CallBackResponse) => {
          this.setState({ loading: false });
        }
      );
    } else {
      // For Single Chaleenges call
      this.props.fetchManageChallengesList(
        this.props.session,
        this.state.searchKey,
        "recurring",
        (CallBackResponse) => {
          this.setState({ loading: false });
        }
      );
    }
  }

  componentDidUpdate(prevProps) {
    //Checking if last update is different
    if (
      prevProps.managechallengesSelectedTab !==
      this.props.managechallengesSelectedTab
    ) {
      this.setState({ loading: true });

      if (this.props.managechallengesSelectedTab == "MANAGECHALLENGES_SINGLE") {
        // Single Challenge
        this.props.fetchManageChallengesList(
          this.props.session,
          this.state.searchKey,
          "single",
          (CallBackResponse) => {
            this.setState({ loading: false });
          }
        );
      } else {
        // For Recurring Chaleenges call
        this.props.fetchManageChallengesList(
          this.props.session,
          this.state.searchKey,
          "recurring",
          (CallBackResponse) => {
            this.setState({ loading: false });
          }
        );
      }
    }
  }

  // OnSearch onchange
  onSearchChallenge = (event) => {
    var search = event.target.value;

    if (this.props.managechallengesSelectedTab == "MANAGECHALLENGES_SINGLE") {
      // Single Challenge
      this.props.fetchManageChallengesList(
        this.props.session,
        search,
        "single",
        (CallBackResponse) => {}
      );
    } else {
      // For Recurring Chaleenges call
      this.props.fetchManageChallengesList(
        this.props.session,
        search,
        "recurring",
        (CallBackResponse) => {}
      );
    }
    this.setState({ searchKey: search });
  };

  // Arrow function for render Manage Challenges Tabs
  renderManagechallengesMenuIcon() {
    return _.map(
      this.props.managechallengesMenu,
      (managechallengesmenuItem) => {
        return (
          <ManagechallengesMenuIcon
            menu={managechallengesmenuItem}
            key={managechallengesmenuItem.key}
          />
        );
      }
    );
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    var arrAvailable = this.props.challengesList.data;

    arrAvailable = arrayMove(arrAvailable, oldIndex, newIndex);

    var newArrAvailable = [];

    this.setState({ activeCount: arrAvailable.length });

    arrAvailable.map((value, index) => {
      newArrAvailable.push({ ...value, displayorder: index + 1 });
    });

    this.setState({ pageLoader: true });
    this.props.updateChallengeList(
      this.props.session,
      this.props.managechallengesSelectedTab,
      newArrAvailable,
      (res) => {
        if (res.success) {
          this.setState({ pageLoader: false });
        } else {
        }
      }
    );
  };

  renderChallengeList() {
    return _.map(this.props.challengesList.data, (Item, index) => {
      return (
        <ManageChallengesItem
          key={Item.id}
          position={index}
          Item={Item}
          searchKey={this.state.searchKey}
        />
      );
    });
  }

  newfc(obj) {
    this.setState({ loader: !this.state.loader });
  }

  closeEventInfo = () => {
    // this.refs.eventInfoPop.hide();
    document.body.click();
  };

  basicEventInfo = () => {
    let className = "event-info-popover-for-icon";
    let style = { maxWidth: 322, width: 322, height: 175 };

    return (
      <Popover
        title={`${LocaleStrings.note}`}
        id="popover-basic-preview-gamification"
        className={className}
        style={style}
      >
        <PopoverHeader>
          <h3 className="popover-title">{LocaleStrings.note}</h3>
        </PopoverHeader>
        <PopoverBody>
          <div className="popover-content">
            <div
              className="dashboard-preview"
              style={{ padding: 12, height: "unset" }}
            >
              <div className="color-subtitle m-2">
                {LocaleStrings.gamification_challenge_note1}
              </div>
            </div>
          </div>
        </PopoverBody>
      </Popover>
    );
  };

  render() {
    let { pageNumber, pageLoader } = this.state;
    var classCustom = "";
    if (pageLoader) {
      classCustom = "page-loading";
    }

    let challengeList = this.props.challengesList.data;
    let pageDataLength =
      this.props.challengesList && this.props.challengesList.data
        ? this.props.challengesList.data.length
        : 0;

    let { deviceSize } = this.props;

    return (
      <div
        className={
          this.state.activeLoader ? "user_main_div" : "panel noborder-panel"
        }
      >
        <div className="content-header-bar">
          <div className="vertical-align-center">
            <div className="btn-group" role="group" aria-label="First group">
              {this.renderManagechallengesMenuIcon()}
            </div>

            <div style={{ marginLeft: "10px" }}>
              <OverlayTrigger
                trigger="hover"
                placement="bottom"
                rootClose
                delay={{ show: 250, hide: 400 }}
                // ref="eventInfoPop"
                overlay={this.basicEventInfo()}
              >
                <img
                  src="../../style/images/header-icons/infoicon.png"
                  alt="info"
                  className="pointer"
                />
              </OverlayTrigger>
            </div>
          </div>

          <div
            className="pull-right h-100 vertical-align-center"
            style={{ marginLeft: "auto" }}
          >
            <EditChallenge history={this.props.history} />
          </div>
          <div className="pull-right h-100 vertical-align-center gamisearchlp">
            <ul className="header-buttons">
              <li
                key={LocaleStrings.button_search}
                className="users-search-input"
              >
                <input
                  id="gamification_manage_challenges_searchid"
                  className="form-control mapsearch"
                  placeholder={LocaleStrings.button_search}
                  type="text"
                  value={this.state.searchKey}
                  onChange={this.onSearchChallenge}
                />
              </li>
            </ul>
          </div>
        </div>

        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <>
              <div className=" gamisearchtabs">
                <ul className="header-buttons">
                  <li
                    key={LocaleStrings.button_search}
                    className="users-search-input"
                  >
                    <input
                      id="gamification_manage_challenges_searchid"
                      className="form-control mapsearch"
                      placeholder={LocaleStrings.button_search}
                      type="text"
                      value={this.state.searchKey}
                      onChange={this.onSearchChallenge}
                    />
                  </li>
                </ul>
              </div>
              {challengeList && challengeList.length > 0 ? (
                <div>
                  <div
                    className="row mb-10"
                    style={{ fontWeight: 700, color: "rgb(195,203,223)" }}
                  >
                    <div
                      className="col-md-4 col-sm-3"
                      style={{ paddingLeft: 58 }}
                    >
                      {LocaleStrings.gamification_list_challengetitle}
                    </div>
                    <div
                      className="col-md-3 col-sm-2"
                      style={{ paddingLeft: 17 }}
                    >
                      {LocaleStrings.gamification_list_description}
                    </div>
                    <div
                      className="col-md-1 col-sm-2"
                      style={{ paddingLeft: 13 }}
                    >
                      {LocaleStrings.gamification_list_showpopup}
                    </div>
                    <div
                      className="col-md-1 col-sm-1"
                      style={{ paddingLeft: 10 }}
                    >
                      {LocaleStrings.gamification_list_points}
                    </div>
                    <div
                      className="col-md-3 col-sm-3"
                      style={{ paddingLeft: 48 }}
                    >
                      {LocaleStrings.gamification_list_action}
                    </div>
                  </div>
                  <div
                    className={`col-md-12 ${classCustom}`}
                    style={{
                      backgroundColor: "#ffffff",
                      backfaceVisibility: "hidden",
                      willChange: "transform",
                      userSelect: "none",
                      WebkitUserSelect: "none",
                      titleBarStyle: "hidden",
                    }}
                  >
                    <SortableSectionList
                      useDragHandle
                      collection={this.props.challengesList.data}
                      onSortEnd={this.onSortEnd}
                      pressDelay={100}
                      axis="y"
                      lockAxis="y"
                      pageDataLength={pageDataLength}
                      currentPage={pageNumber}
                    />
                  </div>
                </div>
              ) : (
                <NoContent contentType={NO_CHALLENGE} />
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var { session, user, managechallengesMenu, managechallengesSelectedTab } =
    state;

  return {
    session,
    user,
    deviceSize: state.deviceSize,
    managechallengesMenu,
    managechallengesSelectedTab,
    challengesList: state.manageChallengesList,
  };
}

// Export with connect
export default connect(mapStateToProps, {
  fetchManageChallengesList,
  openChallengesModal,
  updateChallengeList,
  getStaticTemplteHtml,
})(ManagechallengesInside);
